import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "../css/scheduleTimetable.css";
import ScheduleTabs from "./scheduleTabs";
import ScheduleTable from "./scheduleTable";
import ScheduleTableFacility from "./scheduleTableFacility";
import ScheduleTableClass from "./scheduleTableClass";
import { getScheduleExcelSvc, getScheduleSvc2 } from "./scheduleTimetableSvc";

const ScheduleTeacher = (props) => {
    const { sessionId, setLoader, setOpacity } = props;

    const [lstPeriodHdr, setLstPeriodHdr] = useState([]);
    const [lstDay, setLstDay] = useState([]);
    const [dayId, setDayId] = useState(0);
    const [lstDayTabs, setLstDayTabs] = useState([]);
    const [currentDayData, setCurrentDayData] = useState(null);
    // const [isFacility, setIsFacility] = useState(false);
    const [objType, setObjType] = useState('C');
    // const [objType, setObjType] = useState('T'); // Default to 'T' for Teacher


    useEffect(() => {
        // console.log("ScheduleTeacher called");
        if (sessionId) {
            getScheduleList();
        }
    }, [sessionId, objType]);

    const getScheduleList = () => {
        // console.log("getScheduleList called");
        setLoader("block");
        setOpacity(0.5);
        // const objType = isFacility ? "F" : "T";
        getScheduleSvc2(sessionId, objType, scheuduleListResponse);
    };

    const scheuduleListResponse = (data) => {
        // console.log("scheuduleListResponse called, data", data);
        if (data.status === "Success") {
            setLstPeriodHdr(data.lstPeriodHdr);
            setLstDay(data.lstDay);
            const dayTabs = data.lstDay.map((day) => ({
                dayId: day.dayId,
                day: day.day,
            }));
            // console.log("dayTabs in scheduleListResponse", dayTabs);
            setLstDayTabs(dayTabs);
            // if (dayTabs.length > 0) {
            //     setDayId(dayTabs[0].dayId); // Select the first day by default
            //     setCurrentDayData(data.lstDay.find((d) => d.dayId === dayTabs[0].dayId));
            // }
            if (dayTabs.length > 0) {
                const firstDayId = dayTabs[0].dayId;
                setDayId(firstDayId);
                setCurrentDayData(data.lstDay.find((d) => d.dayId === firstDayId));

                // Create an array to hold all periods for all days
                const allPeriods = data.lstDay.map((day) => {
                    const periodsForDay = data.lstPeriodHdr.filter((period) => period.dayId === day.dayId);
                    return periodsForDay.map((period) => ({
                        sub1: period.sub1,
                        cls1: period.cls1,
                        sec: period.sec,
                        day: day.day, // Add the day for context
                    }));
                }).flat(); // Flatten the array to get a single-level array

                // console.log("All periods for all teachers and all days:", allPeriods);
            }
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    };

    const downloadExcel = () => {
        setLoader("block");
        setOpacity(0.5);
        getScheduleExcelSvc(sessionId, objType, excelResponse);
    };

    const excelResponse = (response) => {
        setLoader("none");
        setOpacity(1);
        // Agar server se file nahi aayi (error case) to khali/corrupt file download na ho
        if (!response || !response.data) {
            toast.error("Excel download failed");
            return;
        }
        // browser ko file download karne ke liye trick:
        var url = document.createElement("a");
        url.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }));
        url.download = "TimeTable Schedule.xlsx";   // download hone wali file ka naam
        document.body.appendChild(url);
        url.click();                                 // khud-ba-khud click ? download shuru
        setTimeout(() => window.URL.revokeObjectURL(url.href), 200);
    };


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to the login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to the login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const handleDayChange = (dayId) => {
        // console.log("handleDayChange called, dayId", dayId);
        setDayId(dayId); // Update the selected day ID
        const selectedDay = lstDay.find((day) => day.dayId === dayId);
        setCurrentDayData(selectedDay || null); // Update the data for the selected day
    };

    return (
        <div className="col-md-12 col-xs-12 col-centered padding-remove">
            {/* Days Tabs */}
            <div className="col-md-12 col-xs-12 padding-remove">
                <div className="schedule-teacher-container">
                    <ScheduleTabs
                        key={dayId}
                        lstDayTabs={lstDayTabs}
                        dayId={dayId}
                        handleDayChange={handleDayChange}
                        objType={objType}
                        setObjType={setObjType}
                        onDownloadExcel={downloadExcel}
                    />
                </div>
            </div>

            {/* Schedule Table */}
            <div className="col-md-12 col-xs-12 padding-remove">
                {
                    objType == 'C' ?
                        <ScheduleTableClass
                            lstPeriodHdr={lstPeriodHdr}
                            currentDayData={currentDayData}
                        />
                        : (objType == 'T' ?
                            <ScheduleTable
                                lstPeriodHdr={lstPeriodHdr}
                                currentDayData={currentDayData}
                            />
                            : <ScheduleTableFacility
                                lstPeriodHdr={lstPeriodHdr}
                                currentDayData={currentDayData}
                            />)
                }
            </div>
        </div>
    );
};

export default ScheduleTeacher;
